// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";           // Firestore
import { getDatabase } from "firebase/database";             // Realtime DB (optional)
import { getAuth } from "firebase/auth";                     // Auth (optional)
import { getStorage } from "firebase/storage";

// Paste the config you got from Firebase console
const firebaseConfig = {
  // apiKey: "AIzaSyAjlH82LKTA7m0X2dpeJUPBxJ83Z4icobs",
  // authDomain: "furrmaa-45315.firebaseapp.com",
  // projectId: "furrmaa-45315",
  // storageBucket: "furrmaa-45315.firebasestorage.app",
  // messagingSenderId: "200582949604",
  // appId: "1:200582949604:web:84b5a8658588a4fd8adaf1",
  // measurementId: "G-KQ8E1MZS8H"

  apiKey: "AIzaSyBgTJqQaRjwPpaxn5-hbOhrUuPceYgv9Tg",
  authDomain: "todo-studio-159af.firebaseapp.com",
  projectId: "todo-studio-159af",
  storageBucket: "todo-studio-159af.appspot.com",
  messagingSenderId: "738986684311",
  appId: "1:738986684311:web:9d35d40595be7c513f1ed2",
  measurementId: "G-MH5KHVLXW2"
};

const app = initializeApp(firebaseConfig);

// Export the modules you will use
export const db = getFirestore(app);        // Firestore (recommended)
export const rtdb = getDatabase(app);       // Realtime Database (if using)
export const storage = getStorage(app);
export const auth = getAuth(app);           // Auth (if using)
export default app;
